import { SourceHandlerMap, SourceName } from "../types";

import { getFirstOrderHandler } from "./get-first-order";

export const SOURCE_HANDLERS: SourceHandlerMap = {
  [SourceName.GET_FIRST_ORDER]: getFirstOrderHandler,
};
